/* hs-eslint ignored failing-rules */
/* eslint-disable react/display-name */

// gimme: conversations-inbox-ui 06/10/2020 24a2e66917cc934433dd111db7e06fd02943ca6a
'use es6';

import { Map as ImmutableMap } from 'immutable';
import PropTypes from 'prop-types';
import { PureComponent, Fragment } from 'react';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import RecordPropType from 'conversations-prop-types/prop-types/RecordPropType';
import UILink from 'UIComponents/link/UILink';
import { getEntryUrlContext, getUrl } from 'conversations-message-history/context-update/operators/contextUpdateGetters';
import { getEditFormRulesUrl } from 'conversations-external-deep-links/urls';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const propTypes = {
  form: PropTypes.instanceOf(ImmutableMap),
  inboxId: PropTypes.number.isRequired,
  message: RecordPropType('ContextUpdateMessage').isRequired
};
class FormContextUpdateMessage extends PureComponent {
  getFormLink(form) {
    return /*#__PURE__*/_jsx(UILink, {
      href: getEditFormRulesUrl({
        formId: form.get('id'),
        inboxId: this.props.inboxId
      }),
      external: true,
      use: "blue",
      children: form.get('name')
    });
  }
  getEntryUrl(entryUrl) {
    const submittedFromUrl = /*#__PURE__*/_jsx(UILink, {
      href: getUrl(entryUrl),
      external: true,
      use: "blue",
      children: getUrl(entryUrl)
    });
    return /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: 'conversations-thread-view.threadHistory.context-update-message.form.formSubmissionLink',
      options: {
        entryUrl: submittedFromUrl
      }
    }, 'form-source-link');
  }
  render() {
    const {
      message,
      form
    } = this.props;
    const entryUrl = getEntryUrlContext(message);
    let linkText;
    let sourceText = /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: 'conversations-thread-view.threadHistory.context-update-message.unknownSourceMessage'
    }, 'form-source-message');
    if (form) {
      sourceText = /*#__PURE__*/_jsx(FormattedReactMessage, {
        message: 'conversations-thread-view.threadHistory.context-update-message.form.formSubmission',
        options: {
          formLink: this.getFormLink(form)
        }
      }, 'form-source-message');
    }
    if (entryUrl) {
      linkText = this.getEntryUrl(entryUrl);
    }
    return /*#__PURE__*/_jsxs(Fragment, {
      children: [/*#__PURE__*/_jsx("div", {
        children: sourceText
      }), /*#__PURE__*/_jsx("div", {
        children: linkText
      })]
    });
  }
}
FormContextUpdateMessage.propTypes = propTypes;
export default FormContextUpdateMessage;